"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { motion } from "framer-motion"
import { Copy, CheckCircle2, AlertCircle, Clock, QrCode } from "lucide-react"
import { useNavigate } from "react-router-dom"

const API = process.env.REACT_APP_API_URL || "https://api.ticketdovaqueiro.com/api"

// 💡 RECEBENDO O basePath AQUI NAS PROPS
export default function CheckoutPixAsaasCircuito({ pedidoId, valor, onSuccess, basePath }) {
  const navigate = useNavigate()

  const [qrCode, setQrCode] = useState(null)
  const [pixCopiaCola, setPixCopiaCola] = useState("")
  const [erro, setErro] = useState("")
  const [expiraEm, setExpiraEm] = useState(null)
  const [contador, setContador] = useState("")
  const [copiado, setCopiado] = useState(false)
  const [expirado, setExpirado] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (typeof window === "undefined" || !pedidoId) return

    const gerarPix = async () => {
      setLoading(true)
      try {
        setErro("")
        let usuarioLogado = null
        try { usuarioLogado = JSON.parse(localStorage.getItem("user")) } catch {}

        const resp = await axios.post(`${API}/pagamento/asaas/pix`, {
          pedidoId,
          totalPedido: Number(valor),
          nomeVaqueiro: usuarioLogado?.nomeCompleto || "Vaqueiro",
          email: usuarioLogado?.email || "",
          cpfCnpj: usuarioLogado?.cpf || "",
          phone: usuarioLogado?.whatsapp || "",
          descricao: `Inscrição Circuito - Pedido ${pedidoId}`,
        })

        if (resp?.data) {
          setQrCode(resp.data.qrCodeBase64 || null)
          setPixCopiaCola(resp.data.copiaECola || "")
          const exp = resp.data.expiracao ? new Date(resp.data.expiracao) : null
          setExpiraEm(exp && !isNaN(exp.getTime()) ? exp : null)
          if (typeof onSuccess === "function") onSuccess(resp.data)
        } else {
          throw new Error("Resposta inválida da API")
        }
      } catch (e) {
        setErro(e?.response?.data?.detail || e.message || "Falha ao gerar Pix Asaas.")
      } finally {
        setLoading(false)
      }
    }

    gerarPix()
  }, [API, pedidoId, valor, onSuccess])

  useEffect(() => {
    if (!expiraEm) return
    const interval = setInterval(() => {
      const agora = new Date()
      const diferenca = expiraEm - agora
      if (diferenca <= 0) {
        setContador("Expirado")
        setExpirado(true)
        clearInterval(interval)
      } else {
        const minutos = Math.floor(diferenca / 60000)
        const segundos = Math.floor((diferenca % 60000) / 1000)
        setContador(`${String(minutos).padStart(2, "0")}:${String(segundos).padStart(2, "0")}`)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [expiraEm])

  // 💡 A MÁGICA ATUALIZADA: Redireciona usando o basePath (funciona p/ domínio próprio ou padrão)
  useEffect(() => {
    if (!pedidoId) return;

    const interval = setInterval(async () => {
      try {
        const res = await axios.get(`${API}/circuitos/pedidos/${pedidoId}/status`);
        if (res.data.status === "pago") {
          clearInterval(interval);
          // Usa o basePath dinâmico
          const caminhoBase = basePath !== undefined ? basePath : "";
          navigate(`${caminhoBase}/associacao-concluida/${pedidoId}`);
        }
      } catch (e) {
        console.error("Aguardando pagamento...");
      }
    }, 4000); 

    return () => clearInterval(interval);
  }, [pedidoId, navigate, basePath]);

  const copiarCodigo = () => {
    if (!pixCopiaCola) return
    navigator.clipboard.writeText(pixCopiaCola)
    setCopiado(true)
    setTimeout(() => setCopiado(false), 2000)
  }

  if (loading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 0" }}>
        <div className="loading-spinner" style={{ borderColor: "rgba(255,255,255,0.1)", borderTopColor: "var(--c-accent)", width: 40, height: 40 }}></div>
        <p style={{ marginTop: 16, color: "#fff", opacity: 0.7 }}>Gerando seu QR Code...</p>
      </div>
    )
  }

  if (erro) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "30px", background: "rgba(239,68,68,0.1)", borderRadius: 12, border: "1px solid rgba(239,68,68,0.2)", color: "#f87171" }}>
        <AlertCircle size={32} style={{ marginBottom: 12 }} />
        <p style={{ textAlign: "center", fontWeight: 500, margin: 0 }}>{erro}</p>
      </div>
    )
  }

  return (
    <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.4 }} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 24 }}>
        <QrCode size={24} color="var(--c-accent)" />
        <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#fff", margin: 0 }}>Pagamento via PIX</h3>
      </div>

      {qrCode && (
        <div style={{ width: "100%", maxWidth: 360, display: "flex", flexDirection: "column", alignItems: "center" }}>
          
          <div style={{ padding: "12px", background: "rgba(16, 185, 129, 0.1)", border: "1px solid rgba(16, 185, 129, 0.3)", borderRadius: "12px", color: "#10b981", fontSize: "13px", fontWeight: "bold", display: "flex", alignItems: "center", gap: "8px", marginBottom: "20px", width: "100%", justifyContent: "center" }}>
             <div className="loading-spinner" style={{ width: 16, height: 16, borderColor: "transparent", borderTopColor: "#10b981" }}></div>
             Aguardando pagamento...
          </div>

          <p style={{ color: "#fff", opacity: 0.8, marginBottom: 24, textAlign: "center", fontSize: "14px" }}>
            Escaneie o QR Code abaixo com o aplicativo do seu banco:
          </p>

          <motion.div initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} style={{ background: "#ffffff", padding: 16, borderRadius: 24, boxShadow: "0 0 0 4px rgba(255,255,255,0.05), 0 12px 30px rgba(0,0,0,0.3)", marginBottom: 32, position: "relative" }}>
            <div style={{ position: "absolute", top: -20, left: -20, right: -20, bottom: -20, background: "var(--c-accent)", filter: "blur(40px)", opacity: 0.15, zIndex: -1, borderRadius: "50%" }} />
            <img src={`data:image/png;base64,${qrCode}`} alt="QR Code Pix" style={{ width: "200px", height: "200px", display: "block" }} />
          </motion.div>

          <div style={{ width: "100%", marginBottom: 24 }}>
            <label style={{ display: "block", fontSize: "13px", color: "#fff", opacity: 0.7, marginBottom: 8, fontWeight: 500, textAlign: "left" }}>Ou copie o código PIX:</label>
            <div style={{ display: "flex", gap: 8 }}>
              <input type="text" value={pixCopiaCola} readOnly className="c-input" style={{ flex: 1, height: "48px", fontSize: "13px", color: "#fff", background: "rgba(0,0,0,0.2)" }} onClick={(e) => e.target.select()} />
              <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={copiarCodigo} disabled={expirado} className="c-btn c-btn--primary" style={{ width: "48px", height: "48px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                {copiado ? <CheckCircle2 size={20} /> : <Copy size={20} />}
              </motion.button>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 16px", background: expirado ? "rgba(239,68,68,0.1)" : "rgba(255,255,255,0.05)", borderRadius: 20, color: expirado ? "#f87171" : "#fff", fontSize: "14px" }}>
            <Clock size={16} color={expirado ? "#f87171" : "var(--c-accent)"} />
            {expirado ? <span>Código expirado.</span> : <span>Expira em: <strong style={{ color: "var(--c-accent)", letterSpacing: 1 }}>{contador}</strong></span>}
          </div>
        </div>
      )}
    </motion.div>
  )
}